<div class="Layoutcontainer" *ngIf="queryDetails.length > 0">
    <div class="pageTitle">
      Previous Query Details
    </div>
    <div class="row">
      <h4 style="text-align: left; margin-left:12px">Query Reference Number - {{queryReferenceNumber}}</h4>
    </div>
    <br>
    <div *ngIf="partnerUserMaster.length > 0 && CCSubDepartmentsMaster.length > 0 ">
      <div *ngFor="let queryDetail of queryDetails; let i = index">
        <button class="text-left" style="line-height: 1.3333333;border-radius: 6px; width: 180px; font-weight: bold;"
          (click)="toggleQuery(i)">Query Detail {{i+1}} <span
            class="pull-right">{{showQueryIndex == i ? '-' : '+'}}</span></button>
        <br>
        <br>
        <div *ngIf="showQueryIndex == i ">
          <app-query-detail-info [queryDetail]="queryDetail" [partnerUserMaster]="partnerUserMaster"
            [CCSubDepartmentsMaster] = "CCSubDepartmentsMaster">
          </app-query-detail-info>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3 col-md-push-2">
          <button nz-button nzType="primary" [nzSize]="'small'" (click)="redirectBack()" >
            Back
          </button>
        </div>
      </div>
    </div>
  </div>